import { NewDynamicTab } from "../../../components/Page";
import { ExchangeAnalysisHPPCDefaultDates } from "../../../config/DefaultDates";
import { TabSwitcher } from "../Raj_Dashboard";
import BuyersAndSellers from "./Tabs/BuyersAndSellers";
import EntityAnalysis from "./Tabs/EntityAnalysis";
import Overview from "./Tabs/Overview";
import Realtime from "./Tabs/Realtime";
import TrendAnalysis from "./Tabs/TrendAnalysis";
const NewExchange = () => {
  return (
    <>
      <NewDynamicTab
        headerHeight="h-[68px]"
        defaultDates={ExchangeAnalysisHPPCDefaultDates}
        headerPrefixComponent={<TabSwitcher />}
        header="Exchange Analytics"
        trendTabs={["Trend Analysis"]}
        tabs={{
          Collective: <Overview />,
          "Trend Analysis": <TrendAnalysis />,
          Realtime: <Realtime />,
          "Buyers & Sellers": <BuyersAndSellers />,
          "Entity Analysis": <EntityAnalysis />,
        }}
      />
    </>
  );
};

export default NewExchange;
